export const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY || "";
